module.exports = __webpack_public_path__ + "static/media/logo-medteck.7b4c017b.png";